

import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useChartConfig } from '../../../Hooks/Features/Overview/useChartConfig';
import _ from 'underscore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog';
import { SkeletonContainer } from '../../Loader/Loader';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { AgGridReact } from '@ag-grid-community/react';

const ChartConfig = ({ createChart, setCreateChart, rowData, columnDefs }) => {

    const { allCharts, createChartValues, setCreateChartValues, chartOptions, showCreateChart, setShowCreateChart, createOpts, handleSave, handleEdit, handleDelete, showPrompt, setShowPrompt, setIdToDelete, loader, detailsView, setDetailsView } = useChartConfig({ createChart, rowData, columnDefs });

    return (
        <div className='px-2'>
            <div className='row pb-1'>
                <div className='col-7'>
                    <h4>User Information</h4>
                </div>
            </div>

            {!loader?.chart ?
                <div className='d-flex flex-wrap justify-content-evenly gap-4'>
                    {allCharts?.map((chart) => (
                        <div className=" border d-flex flex-column" key={chart.chart_configuration_id} style={{ width: `${chart.chart_width}%`, height: (chart.chart_height < 100 || chart.chart_height === null) ? "300px" : `${chart.chart_height}px` }}>
                            <div className='text-right' style={{ padding: '10px' }}>
                                <button onClick={() => handleEdit(chart)} className='btn btn-default'>
                                    <FontAwesomeIcon icon="fa-solid fa-pen-to-square" /></button>
                                <button className='btn btn-default' onClick={() => { setIdToDelete(chart.chart_configuration_id); setShowPrompt(true); }}>
                                    <FontAwesomeIcon icon="fa-solid fa-trash" />
                                </button>
                            </div>
                            <HighchartsReact highcharts={Highcharts} options={chart?.options} />
                        </div>
                    ))}
                </div>
                : <div className='d-flex justify-content-evenly flex-wrap mt-4' style={{ rowGap: "20px" }}>
                    {Array.from({ length: 6 }, (_, index) => (
                        <div style={{ width: "40%", height: "50vh" }} key={index}><SkeletonContainer /></div>
                    ))}
                </div>
            }

            <Dialog visible={showCreateChart} onHide={() => { setShowCreateChart(false); setCreateChart(false); }} draggable={false} className='modal-xlarge'>
                <div>
                    <div className="d-flex w100 justify-content-evenly align-items-center gap-3">
                        <div className='w20'>
                            <span className='bold'>Chart Name: </span>
                            <div><input type="text" placeholder='Enter Chart Name' className='input-dd w100' value={createChartValues?.chartName} onChange={(e) => setCreateChartValues((prev) => ({ ...prev, chartName: e.target.value }))} /></div>
                        </div>

                        <div className='w20'>
                            <span className='bold'>Chart Type: </span>
                            <Dropdown value={createChartValues?.chartType} options={createOpts?.chartOpts} optionLabel='chart_type_name' onChange={(e) => setCreateChartValues((prev) => ({ ...prev, chartType: e.target.value }))} placeholder='Select Chart Type' className='input-dd' filter filterInputAutoFocus />
                        </div>

                        <div className='w10'>
                            <span className='bold'>X-Axis Column: </span>
                            <Dropdown value={createChartValues?.xAxis} onChange={(e) => setCreateChartValues((prev) => ({ ...prev, xAxis: e.target.value }))} options={createOpts?.xAxisOpts} optionLabel='label' placeholder='Select X-Axis' className='input-dd' filter filterInputAutoFocus />
                        </div>

                        <div className='w20'>
                            <span className='bold'>Y-Axis Column: </span>
                            <Dropdown value={createChartValues?.yAxis} onChange={(e) => setCreateChartValues((prev) => ({ ...prev, yAxis: e.target.value }))} options={createOpts?.yAxisOpts} optionLabel='label' placeholder='Select Y-Axis' className='input-dd' filter filterInputAutoFocus />
                        </div>

                        <div className='w20'>
                            <span className='bold'>Chart Analytics: </span>
                            <Dropdown value={createChartValues?.chartAnalytics} onChange={(e) => setCreateChartValues((prev) => ({ ...prev, chartAnalytics: e.target.value }))} options={createOpts?.chartAnalyticsOpts} optionLabel='chart_analytic_name' placeholder='Select Chart Analytics' className='input-dd' filter filterInputAutoFocus />
                        </div>

                        <div className='w20'>
                            <span className='bold'>Chart Width: (%)</span>
                            <div><input type="number" placeholder='Enter Width' className='input-dd w100' value={createChartValues?.width} onChange={(e) => setCreateChartValues((prev) => ({ ...prev, width: e.target.value }))} /></div>
                        </div>

                        <div className='w20'>
                            <span className='bold'>Chart Height: (px)</span>
                            <div><input type="number" placeholder='Enter Height' className='input-dd w100' value={createChartValues?.height} onChange={(e) => setCreateChartValues((prev) => ({ ...prev, height: e.target.value }))} /></div>
                        </div>

                        <div className='w20'>
                            <span className='bold'>Chart Order: </span>
                            <div><input type="number" placeholder='Enter Order' className='input-dd w100' value={createChartValues?.chart_order} onChange={(e) => setCreateChartValues((prev) => ({ ...prev, chart_order: e.target.value }))} /></div>
                        </div>


                    </div>
                    {!_.isEmpty(createChartValues?.chartType) &&
                        <div className="highcharts-container d-flex justify-content-center mt-4">
                            <HighchartsReact highcharts={Highcharts} options={chartOptions} containerProps={{ style: { width: `${createChartValues?.width}%`, height: (parseInt(createChartValues?.height) < 100 || createChartValues?.height?.length === 0) ? "300px" : `${createChartValues?.height}px` } }} />
                        </div>
                    }
                    <div className='d-flex gap-2 justify-content-end mt-3'>
                        <button className='btn-default' onClick={() => { setShowCreateChart(false); setCreateChart(false); }}>Cancel</button>
                        {loader?.btn ? <button style={{width: "48px"}}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className='btn-primary' onClick={() => handleSave()}>Save</button>}
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={showPrompt} handleClose={() => setShowPrompt(false)} handleFun={() => handleDelete()} message="Are you sure you want to delete the chart?" />

            <Dialog visible={detailsView?.visible} onHide={() => setDetailsView((prev) => ({ ...prev, visible: false, data: [], header: "" }))} draggable={false} className='modal-xlarge' header={detailsView?.header}>
                <div className='ag-theme-alpine' style={{ height: "60vh" }}>
                    <AgGridReact columnDefs={detailsView?.column_def} rowData={detailsView?.data} rowHeight={30} />
                </div>
            </Dialog>
        </div>
    );
};

export default ChartConfig;
